import "../sentry.ts";
import { createRoot } from "react-dom/client";
// Axios
// import axios from 'axios'
// import { Chart, registerables } from 'chart.js'
// Apps
import { MetronicI18nProvider } from "./_metronic/i18n/Metronici18n";
import { I18nProvider } from "./_metronic/i18n/i18nProvider";
import "./_metronic/assets/sass/style.react.scss";
import "./_metronic/assets/fonticon/fonticon.css";
import "./_metronic/assets/keenicons/duotone/style.css";
import "./_metronic/assets/keenicons/outline/style.css";
import "./_metronic/assets/keenicons/solid/style.css";
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import "./_metronic/assets/sass/style.scss";
import "./_metronic/assets/sass/plugins.scss";
import { AppRoutes } from "./app/routing/AppRoutes";
import { Provider } from "react-redux";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { persistor, store } from "./store/store";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PersistGate } from "redux-persist/integration/react";
import { MetronicSplashScreenProvider } from "./_metronic/layout/core";
import { DynamicRouteProvider } from "./app/routing/DynamicRouteProvider";
import SignalRProvider from "./app/services/signalR/SignalRProvider";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import SessionExpiredModal from "./app/components/SessionExpiredModal/SessionExpiredModal";
import VersionCheck from "./app/components/VersionCheck/VersionCheck.tsx";
import AppErrorFallback from "./app/components/AppErrorFallback/AppErrorFallback.tsx";
import { installStaleBuildRecovery } from "./app/utils/staleBuildRecovery.ts";
import { ErrorBoundary } from "@sentry/react";

// AG Grid Module Registration
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
ModuleRegistry.registerModules([AllCommunityModule]);
// used for broadCasting
// import { APP_ROUTES } from './app/routing/routes.tsx'
// end used for broadCasting

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// Chart.register(...registerables)

// Outside React, so a crash caught by the error boundary can't remove it.
installStaleBuildRecovery();

const container = document.getElementById("root");


// it is used for clickjacking
if (window.top && window.top !== window.self) {
  window.top.location = window.self.location.href;
}

// Root management for hot reloading
let root: ReturnType<typeof createRoot> | null = null;

const App = () => {
  //   const [appVersion, setAppVersion] = useState(import.meta.env.VITE_APP_VERSION);

  //   useEffect(() => {
  //     const handleVersionUpdate = () => {
  //       setAppVersion(import.meta.env.VITE_APP_VERSION);
  //     };

  //     // Listen for version updates
  //     window.addEventListener("versionUpdate", handleVersionUpdate);
  //     return () => window.removeEventListener("versionUpdate", handleVersionUpdate);
  //   }, []);
  // console.log(appVersion, 'appVersion')
  return (
    // VersionCheck sits above the boundary so a caught crash can't unmount the poller.
    <VersionCheck>
      <ErrorBoundary fallback={({ error }) => <AppErrorFallback error={error} />}>
        {/* <PersistGate persistor={persistor}> */}
        <Provider store={store}>
          <MetronicI18nProvider>
            <I18nProvider>
              <GoogleReCaptchaProvider
                reCaptchaKey={import.meta.env.VITE_APP_GOOGLE_RECAPTCHA_KEY}
              // language="[optional_language]"
              // useRecaptchaNet="[optional_boolean_value]"
              // useEnterprise="[optional_boolean_value]"
              // scriptProps={{
              //   async: false, // optional, default to false,
              //   defer: false, // optional, default to false
              //   appendTo: 'head', // optional, default to "head", can be "head" or "body",
              //   nonce: undefined // optional, default undefined
              // }}
              // container={{ // optional to render inside custom element
              //   element: "[required_id_or_htmlelement]",
              //   parameters: {
              //     badge: '[inline|bottomright|bottomleft]', // optional, default undefined
              //     theme: 'dark', // optional, default undefined
              //   }
              // }}
              >
                <MetronicSplashScreenProvider>
                  <DynamicRouteProvider>
                    {/* <AuthProvider> */}
                    <SignalRProvider>
                      <AppRoutes />
                    </SignalRProvider>
                    {/* <AppRoute /> */}
                    {/* </AuthProvider> */}
                  </DynamicRouteProvider>
                  <SessionExpiredModal />
                </MetronicSplashScreenProvider>
              </GoogleReCaptchaProvider>
            </I18nProvider>
          </MetronicI18nProvider>
        </Provider>
        {/* </PersistGate> */}

      </ErrorBoundary>
    </VersionCheck>
  );
};

// Function to render the app
const renderApp = () => {
  if (!container) return;

  try {
    // If root exists, unmount it first
    if (root) {
      root.unmount();
      root = null;
    }

    // Clear the container
    container.innerHTML = '';

    // Create a new root instance
    root = createRoot(container);
    root.render(<App />);
  } catch (error) {
    console.error('Error rendering app:', error);
    // Fallback: try to render without clearing
    if (!root) {
      root = createRoot(container);
    }
    root.render(<App />);
  }
};

// Initial render
renderApp();

// Handle hot reloading
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    renderApp();
  });
}
